import calamityService from "../api/server/calamityService";
import authentication from "@/authentication";
import moment from "moment";
export const CALAMITY_NAMESPACE = "calamityModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/calamityService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(calamityService)
};

const state = {
  calamities: [],
  calamityPackageList: {},
  carrierRequestPackages: [],
  loading: true
};

const actions = {
  async CLOSE_CALAMITY(context, data) {
    var api = await services.api;
    state.loading = true;
    return api.closeCalamity(data).then(function(value) {
      actions.LOAD(context);
      return value;
    });
  },
  async EDIT_CLIENT_EMAIL(context, data) {
    var api = await services.api;
    return api.editClientEmail(data).then(function(value) {
      state.calamities.forEach(x => {
        if (x.Id === data.calamityId)
          x.NotificationRecipients = data.notificationRecipients;
      });
      return value;
    });
  },
  async getCalamitySummary(context, idLists) {
    context.state.calamityPackageList = [];
    var api = await services.api;
    return api.getCalamitySummary(idLists).then(function(value) {
      context.commit("setCalamityCallPackages", value);
      return value;
    });
  },
  async LOAD(context) {
    var api = await services.api;
    state.loading = true;
    context.commit("CLEAR_CALAMITIES");
    return api.load().then(function(value) {
      context.commit("SET_CALAMITIES", value);
    });
  },
  async LOAD_CARRIER_REQUEST(context, data) {
    var api = await services.api;
    state.loading = true;
    return api.loadCarrierRequest(data.calamityId).then(function(value) {
      context.commit("SET_CARRIER_REQUEST_PACKAGES", value);
    });
  },
  async getCalamityCallsStatus(context, data) {
    var api = await services.api;
    return api.getCalamityCallsStatus(data).then(function(value) {
      return value;
    });
  },
  async cancelCalamityCalls(context, data) {
    var api = await services.api;
    return api.cancelCalamityCalls(data).then(function(value) {
      return value;
    });
  },
  async sendCalamityCalls(context, data) {
    var user = authentication.getUser();
    var payload = {
      Name: user.profile.name,
      ActiveDirectoryId: user.profile.oid,
      UniqueName: user.profile.unique_name,
      PartitionKey: user.profile.oid,
      RowKey: Date.now(),
      CalamityCallsSendList: data
    };
    var api = await services.api;
    return api.sendCalamityCalls(payload).then(function(value) {
      return value;
    });
  },
  async SEND_CARRIER_REQUEST(context, data) {
    var api = await services.api;
    state.loading = true;
    let req = context.state.carrierRequestPackages.map(function(x) {
      return {
        PackageId: x.PackageId,
        HighPriority: x.HighPriority ? x.HighPriority : false
      };
    });
    let payload = {
      calamityActionId: context.state.carrierRequestPackages[0].RequestType,
      calamityId: data.calamityId,
      packages: req
    };
    return api.sendCarrierRequest(payload).then(function(value) {
      context.commit("CLEAR_CARRIER_REQUEST_PACKAGES", value);
      return value;
    });
  },
  async SEND_CLIENT_EMAIL(context, data) {
    var api = await services.api;
    state.loading = true;
    return api.sendClientEmail(data).then(function(value) {
      state.loading = false;
      return value;
    });
  }
};

const mutations = {
  CLEAR_CALAMITIES(storeState, data) {
    storeState.calamities = [];
  },
  CLEAR_CARRIER_REQUEST_PACKAGES(storeState, data) {
    storeState.carrierRequestPackages = [];
    storeState.loading = false;
  },
  SET_CALAMITIES(storeState, data) {
    storeState.calamities = data;
    storeState.loading = false;
  },
  SET_CARRIER_REQUEST_PACKAGES(storeState, data) {
    storeState.carrierRequestPackages = data;
    storeState.loading = false;
  },
  setCalamityCallPackages(storeState, data) {
    storeState.calamityPackageList = {};
    for (let clientId in data.Options) {
      var packages = data.CalamitySummaries.filter(x => x.ClientId == clientId);
      if (packages.length > 0) {
        storeState.calamityPackageList[clientId] = {};
        storeState.calamityPackageList[clientId].ClientName =
          packages[0].ClientName;
        storeState.calamityPackageList[clientId].selected = [];
        storeState.calamityPackageList[clientId].ClientId = clientId;
        storeState.calamityPackageList[clientId].CallOptions = {};
        storeState.calamityPackageList[clientId].CalamityList = [];
        data.Options[clientId].forEach(y => {
          if (y.Id === 98)
            storeState.calamityPackageList[clientId].callsPerHour = y.Value;
          // eslint-disable-next-line
          storeState.calamityPackageList[clientId].CallOptions["Option_" + y.Id] = y.Value;
        });
        var sortedPackages = {};

        packages.forEach(x => {
          if (!sortedPackages[x.CalamityId]) sortedPackages[x.CalamityId] = [];
          sortedPackages[x.CalamityId].push(x);
        });

        for (let calamityId in sortedPackages) {
          var transitStates = {};
          var timeZones = {};
          var deliveryDates = {};
          sortedPackages[calamityId].forEach(x => {
            var date = moment(x.ScheduledDeliveryDate).format("YYYY-MM-DD");
            x.ScheduledDeliveryDate = date;
            if (!transitStates[x.TransitState])
              transitStates[x.TransitState] = {
                Id: x.TransitStateId,
                Name: x.TransitState,
                Total: 0,
                Eligible: 0,
                Ineligible: 0
              };
            if (!timeZones[x.TimeZoneName])
              timeZones[x.TimeZoneName] = {
                Offset: x.TimeZoneOffset,
                Name: x.TimeZoneName,
                Total: 0,
                Eligible: 0,
                Ineligible: 0
              };
            if (!deliveryDates[date])
              deliveryDates[date] = {
                Date: date,
                Eligible: 0,
                Ineligible: 0,
                Total: 0
              };
            if (x.NeedsNotification) deliveryDates[date].Eligible++;
            if (x.Ineligible) deliveryDates[date].Ineligible++;
            deliveryDates[date].Total++;

            if (x.NeedsNotification) transitStates[x.TransitState].Eligible++;
            if (x.Ineligible) transitStates[x.TransitState].Ineligible++;
            transitStates[x.TransitState].Total++;

            timeZones[x.TimeZoneName].Total++;
            if (x.NeedsNotification) timeZones[x.TimeZoneName].Eligible++;
            if (x.Ineligible) timeZones[x.TimeZoneName].Ineligible++;
          });

          var transitStatesArr = [];
          for (let x in transitStates) transitStatesArr.push(transitStates[x]);
          transitStatesArr.sort(function(a, b) {
            return a.Id - b.Id;
          });
          /* eslint-disable */
          var summary = {
            CalamityId: calamityId,
            ClientId: clientId,
            ClientName: sortedPackages[calamityId][0].ClientName,
            ContentsValue: sortedPackages[calamityId].filter(x => x.NeedsNotification).reduce((a, b) => a + b.ContentsValue, 0),
            ContentsValueIneligible:sortedPackages[calamityId].filter(x => x.Ineligible).reduce((a, b) => a + b.ContentsValue, 0),
            ContentsValueTotal: sortedPackages[calamityId].reduce((a, b) => a + b.ContentsValue, 0),
            RefContentsValue: sortedPackages[calamityId].filter(x => x.IsRef && x.NeedsNotification).reduce((a, b) => a + b.ContentsValue, 0),
            RefContentsValueIneligible: sortedPackages[calamityId].filter(x => x.IsRef && x.Ineligible).reduce((a, b) => a + b.ContentsValue, 0),
            RefContentsValueTotal: sortedPackages[calamityId].filter(x => x.IsRef).reduce((a, b) => a + b.ContentsValue, 0),
            NeedsCalls: sortedPackages[calamityId].filter(x => x.NeedsNotification).length,
            Ineligible: sortedPackages[calamityId].filter(x => x.Ineligible).length,
            TotalPackages: sortedPackages[calamityId].length,
            Refrigerated: sortedPackages[calamityId].filter(x => x.IsRef && x.NeedsNotification).length,
            RefrigeratedIneligible: sortedPackages[calamityId].filter(x => x.IsRef && x.Ineligible).length,
            RefrigeratedTotal: sortedPackages[calamityId].filter(x => x.IsRef).length,
            Packages: sortedPackages[calamityId],
            Notified: sortedPackages[calamityId].filter(x => x.Notified).length,
            Closed: sortedPackages[calamityId].filter(x => x.ProtectionStateId === 4).length,
            Cpu: sortedPackages[calamityId].filter(x => x.RootCauseId === 62).length,
            CsrCpu: sortedPackages[calamityId].filter(x => x.RootCauseId === 67).length,
            MonCpu: sortedPackages[calamityId].filter(x => x.RootCauseId === 79).length,
            Tier2: sortedPackages[calamityId].filter(x => x.Tier === 2).length,
            ReturnToSender: sortedPackages[calamityId].filter(x => x.IsRTS).length,
            DoNotContact: sortedPackages[calamityId].filter(x => x.IsDNC).length,
            PastDeliveryDate: sortedPackages[calamityId].filter(x => !x.TodayDelivery === -1).length,
            CurrentPastDeliveryDate: sortedPackages[calamityId].filter(x => !x.TodayDelivery === 0).length,
            FutureDeliveryDate: sortedPackages[calamityId].filter(x => !x.TodayDelivery === 1).length,
            TransitStates: transitStatesArr,
            TimeZones: timeZones,
            DeliveryDates: deliveryDates,
            isSelected: false
          };
          /* eslint-enable */
          summary.ContentsValue = parseFloat(summary.ContentsValue.toFixed(2));
          summary.RefContentsValue = parseFloat(
            summary.RefContentsValue.toFixed(2)
          );
          if (summary.NeedsCalls > 0) summary.isSelected = true;
          state.calamityPackageList[clientId].CalamityList.push(summary);
        }
      }
    }
  }
};

const getters = {
  calamities: storeState => storeState.calamities,
  calamityPackageList: storeState => storeState.calamityPackageList,
  carrierRequestPackages: storeState => storeState.carrierRequestPackages,
  loading: storeState => storeState.loading
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
